import React, { useState } from 'react';
import './Login.css';
import logo from '../Assets/sdspc-logo.png';
import sideimage from '../Assets/loginSideImage.jpg';
import api from "../services/api";
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [mobile, setmobile] = useState('');
  const [error, setError] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle login logic here
    console.log('Login attempted with:', { mobile, password });

    const response = await api.post("/login.php", { mobile, password });

    if (response.data.head.code === 200) {
      navigate('/home');
    } else {
      setError(response.data.head.msg);
    }
  };

  return (
    <div className="login-page-wrapper">
      <div className="login-main-container">
        {/* Logo in top left corner (desktop/tablet) */}
        <div className="logo-section">
          {/* <img className="logo-main" src={logo} alt="SDS Polytechnic College Logo" /> */}
          <h3>Sri Vinayaga Wire Industries</h3>
        </div>

        {/* Main Content with Side Image and Login Card */}
        <div className="login-content-container">
          {/* Side Image */}
          <div className="side-image-container">
            <img className="side-image" src={sideimage} alt="Campus View" />
          </div>

          {/* Login Card */}

          <div className="login-card-container">

            <div className="login-card">
              {/* Logo inside card for mobile (hidden on larger screens) */}
              {/* <img src={logo} alt="SDS Logo" className="logo-inside" /> */}
              <h3 className="logo-inside">Sri Vinayaga Wire Industries</h3>
              {/* className="welcome-text" */}
              <div className='top-welcome'></div>
              {error != "" && (
                <p style={{ color: "red", fontSize: "20px", textAlign: "center" }}>Please Enter Correct login Details !</p>
              )

              }
              <p className="welcome-text">Welcome to<br /> Sri Vinayaga Wires</p>

              {/* Left aligned instruction above mobile (always present) */}
              <h6 className="login-instruction-left">Log in Your Account</h6>

              <form onSubmit={handleSubmit} className="login-form">
                <div className="form-group floating">
                  <input
                    type="text"
                    id="mobile"
                    value={mobile}
                    onChange={(e) => setmobile(e.target.value)}
                    placeholder=" "
                    required
                    className="floating-input"
                    aria-label="mobile"
                  />
                  <label htmlFor="mobile" className="floating-label">Mobile</label>
                </div>

                <div className="form-group floating">
                  <input
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder=" "
                    required
                    className="floating-input"
                    aria-label="password"
                  />
                  <label htmlFor="password" className="floating-label">Password</label>
                </div>

                <button type="submit" className="login-button">Log In</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
